import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2641d475"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = { class: "card-body py-4" }
const _hoisted_3 = { class: "row g-3 align-items-end" }
const _hoisted_4 = { class: "col-md-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-muted" }, "From", -1))
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-muted" }, "To", -1))
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-muted" }, "User ID (optional)", -1))
const _hoisted_10 = { class: "col-md-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-muted" }, "Status", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Won", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Open", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Lost", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "All", -1))
const _hoisted_16 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-8 text-muted" }, "Threshold (seconds)", -1))
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = { class: "form-check form-switch mb-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-8",
  for: "flaggedOnly"
}, "Suspicious only", -1))
const _hoisted_22 = { class: "form-check form-switch mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-8",
  for: "firstHalfOnly"
}, "1st half bets only", -1))
const _hoisted_24 = { class: "col-md-1 text-end" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning d-flex align-items-start gap-3 mb-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle fs-3" }),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mb-1" }, "Goal times are reconstructed, not recorded."),
    /*#__PURE__*/_createTextVNode(" Nothing stores the moment a goal happens, so goal times here are derived from the provider's period start plus the event minute — accurate to roughly "),
    /*#__PURE__*/_createElementVNode("strong", null, "±60 seconds"),
    /*#__PURE__*/_createTextVNode(". Bet times are exact. Read this for a repeated pattern across many coupons, not as proof about a single one. ")
  ])
], -1))
const _hoisted_27 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_28 = { class: "col-md-3 mb-4" }
const _hoisted_29 = { class: "card h-100" }
const _hoisted_30 = { class: "card-body text-center py-4" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted mb-1" }, "Coupons scanned", -1))
const _hoisted_32 = { class: "fs-2 fw-bold" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted" }, "placed after kickoff", -1))
const _hoisted_34 = { class: "col-md-3 mb-4" }
const _hoisted_35 = { class: "card h-100" }
const _hoisted_36 = { class: "card-body text-center py-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted mb-1" }, "Flagged", -1))
const _hoisted_38 = { class: "fs-8 text-muted" }
const _hoisted_39 = { class: "col-md-3 mb-4" }
const _hoisted_40 = { class: "card h-100" }
const _hoisted_41 = { class: "card-body text-center py-4" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted mb-1" }, "Shown", -1))
const _hoisted_43 = { class: "fs-2 fw-bold" }
const _hoisted_44 = { class: "fs-8 text-muted" }
const _hoisted_45 = { class: "col-md-3 mb-4" }
const _hoisted_46 = { class: "card h-100" }
const _hoisted_47 = { class: "card-body text-center py-4" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted mb-1" }, "Games without timing", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted" }, "could not be reconstructed", -1))
const _hoisted_50 = {
  key: 1,
  class: "card"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body text-center py-10 text-muted" }, " No coupons matched. Either nothing suspicious in this range, or no bets were placed after kickoff. ", -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "card-body py-4" }
const _hoisted_54 = { class: "d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4" }
const _hoisted_55 = { class: "fw-bold fs-5" }
const _hoisted_56 = { class: "fs-8 text-muted mt-1" }
const _hoisted_57 = { class: "text-end" }
const _hoisted_58 = { class: "badge badge-light me-2" }
const _hoisted_59 = { class: "badge badge-light" }
const _hoisted_60 = {
  key: 0,
  class: "mt-2 fs-7"
}
const _hoisted_61 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2" }
const _hoisted_62 = { class: "fw-semibold" }
const _hoisted_63 = {
  key: 0,
  class: "badge badge-light-success ms-2 fs-9"
}
const _hoisted_64 = {
  key: 1,
  class: "badge badge-light-warning ms-2 fs-9"
}
const _hoisted_65 = {
  key: 2,
  class: "badge badge-light ms-2 fs-9"
}
const _hoisted_66 = { class: "fs-8 text-muted" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "text-end fs-8" }
const _hoisted_69 = { class: "text-muted" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  key: 0,
  class: "fs-8 text-muted ps-3"
}
const _hoisted_72 = {
  key: 1,
  class: "table table-sm table-row-dashed fs-8 mb-0"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"70px"} }, "Minute"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"110px"} }, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Scorer"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"170px"} }, "Goal time (UTC, ±60s)"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"200px"} }, "Gap to bet")
  ])
], -1))
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_76 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_77 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.from) = $event)),
              type: "date",
              class: "form-control form-control-sm form-control-solid"
            }, null, 512), [
              [_vModelText, _ctx.from]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.to) = $event)),
              type: "date",
              class: "form-control form-control-sm form-control-solid"
            }, null, 512), [
              [_vModelText, _ctx.to]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userId) = $event)),
              type: "number",
              placeholder: "all users",
              class: "form-control form-control-sm form-control-solid"
            }, null, 512), [
              [_vModelText, _ctx.userId]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statusId) = $event)),
              class: "form-select form-select-sm form-select-solid"
            }, _hoisted_16, 512), [
              [_vModelSelect, _ctx.statusId]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.thresholdSeconds) = $event)),
              type: "number",
              min: "0",
              class: "form-control form-control-sm form-control-solid"
            }, null, 512), [
              [
                _vModelText,
                _ctx.thresholdSeconds,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.flaggedOnly) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "flaggedOnly"
              }, null, 512), [
                [_vModelCheckbox, _ctx.flaggedOnly]
              ]),
              _hoisted_21
            ]),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.firstHalfOnly) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "firstHalfOnly"
              }, null, 512), [
                [_vModelCheckbox, _ctx.firstHalfOnly]
              ]),
              _hoisted_23
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary w-100",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args))),
              disabled: _ctx.loading
            }, _toDisplayString(_ctx.loading ? "…" : "Run"), 9, _hoisted_25)
          ])
        ])
      ])
    ]),
    _hoisted_26,
    (_ctx.report)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.report.couponsScanned), 1),
                _hoisted_33
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", {
                  class: _normalizeClass(["fs-2 fw-bold", _ctx.report.couponsFlagged > 0 ? 'text-danger' : 'text-success'])
                }, _toDisplayString(_ctx.report.couponsFlagged), 3),
                _createElementVNode("div", _hoisted_38, "within " + _toDisplayString(_ctx.report.thresholdSeconds) + "s of a goal", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.report.coupons.length), 1),
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.flaggedOnly ? "suspicious only" : "all in-play coupons"), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", {
                  class: _normalizeClass(["fs-2 fw-bold", _ctx.report.gamesWithoutTiming.length > 0 ? 'text-warning' : ''])
                }, _toDisplayString(_ctx.report.gamesWithoutTiming.length), 3),
                _hoisted_49
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.report && _ctx.report.coupons.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report?.coupons ?? [], (coupon) => {
      return (_openBlock(), _createElementBlock("div", {
        key: coupon.couponId,
        class: _normalizeClass(["card mb-4", _ctx.couponBorderClass(coupon)])
      }, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_55, "#" + _toDisplayString(coupon.couponId), 1),
              (coupon.userId)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "ms-3 text-primary",
                    to: '/users/edit/' + coupon.userId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(coupon.nickName || "user " + coupon.userId), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_56, " Placed " + _toDisplayString(_ctx.formatDateTime(coupon.createdAtUtc)) + " UTC ", 1)
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("span", {
                class: _normalizeClass(["badge me-2", _ctx.statusBadgeClass(coupon.statusId)])
              }, _toDisplayString(_ctx.statusText(coupon.statusId)), 3),
              _createElementVNode("span", _hoisted_58, _toDisplayString(coupon.coins) + " coins", 1),
              _createElementVNode("span", _hoisted_59, "odd " + _toDisplayString(coupon.totalOdd), 1),
              (coupon.minSecondsAfterGoal !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createTextVNode(" Closest goal: "),
                    _createElementVNode("span", {
                      class: _normalizeClass(["fw-bold", _ctx.gapTextClass(coupon.minSecondsAfterGoal)])
                    }, _toDisplayString(_ctx.formatGap(coupon.minSecondsAfterGoal)) + " before the bet ", 3)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coupon.bets, (bet, betIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: betIndex,
              class: "bet-block mb-3"
            }, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_62, [
                    _createTextVNode(_toDisplayString(bet.homeTeamName) + " - " + _toDisplayString(bet.awayTeamName) + " ", 1),
                    (bet.placedInFirstHalf === true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, "1st half"))
                      : (bet.placedInFirstHalf === false)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, "after the interval"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_65, "half unknown"))
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createTextVNode(_toDisplayString(bet.marketName), 1),
                    (bet.marketDescription)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(bet.marketDescription), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" · " + _toDisplayString(bet.oddLabel) + " @ " + _toDisplayString(bet.oddValue), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, "Kickoff " + _toDisplayString(_ctx.formatDateTime(bet.gameDateUtc)), 1),
                  (bet.secondsAfterKickoff !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, " Bet placed " + _toDisplayString(_ctx.formatGap(bet.secondsAfterKickoff)) + " after kickoff ", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              (bet.goals.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, " No goals recorded for this game. "))
                : (_openBlock(), _createElementBlock("table", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bet.goals, (goal, goalIndex) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: goalIndex,
                          class: _normalizeClass({ 'goal-suspicious': _ctx.isSuspiciousGoal(goal) })
                        }, [
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(goal.minute), 1),
                            (goal.extraMinute)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_74, "+" + _toDisplayString(goal.extraMinute), 1))
                              : _createCommentVNode("", true),
                            _createTextVNode("' ")
                          ]),
                          _createElementVNode("td", null, _toDisplayString(goal.type), 1),
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(goal.playerName || "—") + " ", 1),
                            (goal.isHomeTeam)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75, " (" + _toDisplayString(goal.isHomeTeam === 1 ? bet.homeTeamName : bet.awayTeamName) + ") ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(goal.goalTimeUtc ? _ctx.formatDateTime(goal.goalTimeUtc) : "unavailable"), 1),
                          _createElementVNode("td", null, [
                            (goal.secondsToBet === null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_76, "—"))
                              : (goal.secondsToBet < 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_77, " bet came " + _toDisplayString(_ctx.formatGap(-goal.secondsToBet)) + " earlier ", 1))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    class: _normalizeClass([_ctx.gapTextClass(goal.secondsToBet), "fw-semibold"])
                                  }, " bet " + _toDisplayString(_ctx.formatGap(goal.secondsToBet)) + " after ", 3))
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ]))
            ]))
          }), 128))
        ])
      ], 2))
    }), 128))
  ]))
}